var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('custom-page-table',{ref:"table2",attrs:{"rowKey":"id","columns":_vm.columns,"requestPromise":_vm.loadPromise}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }